<div
  cdkDrag
  cdkDragBoundary=".cdk-overlay-container"
  cdkDragRootElement=".cdk-overlay-pane"
  class="not-see-through"
>
  <button mat-fab class="collapseBtn" matTooltip="Dock Widget" (click)="dock()">
    <sn-icon fontIcon="fa-minus" fontSet="far"></sn-icon>
  </button>
  <div cdkDragHandle class="drag-handle">
    <sn-icon>drag_indicator</sn-icon>
  </div>
  <ng-container [ngSwitch]="widget.widget">
    <fs-alarms-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'alert'"
    ></fs-alarms-widget>
    <sn-camera-live-view-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'camera_live_view'"
    ></sn-camera-live-view-widget>
    <sn-camera-grids-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'camera_grids'"
    ></sn-camera-grids-widget>
    <sn-analytics-widget
      #analytics
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'heatmap_analytics'"
    ></sn-analytics-widget>
    <sn-chat-channel-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      (widgetUpdated)="onWidgetUpdated($event)"
      *ngSwitchCase="'chat_channel'"
    ></sn-chat-channel-widget>
    <sn-embed-youtube-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'embed_youtube'"
    ></sn-embed-youtube-widget>
    <sn-embed-code-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'embed_code'"
    ></sn-embed-code-widget>
    <sn-facebook-live-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'facebook_live'"
    ></sn-facebook-live-widget>
    <sn-content-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      (widgetUpdated)="onWidgetUpdated($event)"
      *ngSwitchCase="'content'"
    ></sn-content-widget>
    <sn-twitter-embed-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'twitter_timeline_embed'"
    ></sn-twitter-embed-widget>
    <sn-website-iframe-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'website_iframe'"
    ></sn-website-iframe-widget>
    <sn-media-widget
      [widget]="widget"
      [viewId]="widget.operationalView"
      *ngSwitchCase="'media_widget'"
    ></sn-media-widget>
  </ng-container>
</div>
